import ProfilEdit from "./ProfileEdit"

const SideNavDetail = (props) => {
    return (
            <div className="profile-right-sec">

                <ProfilEdit setIsLoading = {props.setIsLoading}/>

            </div>)
}
export default SideNavDetail;